import React from "react";
import styles from "./InformationTextInForm.module.scss";

const InformationTextInForm = ({ children, additionalClassNames }) => <p className={`${styles.InfoText} ${additionalClassNames}`}>{children}</p>;

export default InformationTextInForm;
